import type { AiProviderSettings } from '../../admin/types/AiPromptConfig';

export type SubagentModelOption = {
  value: string;
  label: string;
  providerId: string;
};

const EXPLICIT_PROVIDERS = new Set(['AzureOpenAI', 'OpenAI', 'DeepSeek']);

export const isSubagentModelSelectable = (subagentChatProvider: string): boolean =>
  EXPLICIT_PROVIDERS.has(subagentChatProvider);

export const buildSubagentModelOptions = (
  settings: AiProviderSettings | null,
  subagentChatProvider: string,
): SubagentModelOption[] => {
  if (!settings || !isSubagentModelSelectable(subagentChatProvider)) {
    return [];
  }

  const provider = settings.providers.find((item) => item.id === subagentChatProvider);
  if (!provider?.isConfigured || !provider.model?.trim()) {
    return [];
  }

  return [{
    value: provider.model.trim(),
    label: provider.model.trim(),
    providerId: provider.id,
  }];
};

export const resolveSubagentModelIdForProvider = (
  settings: AiProviderSettings | null,
  subagentChatProvider: string,
  currentModelId: string,
): string => {
  const options = buildSubagentModelOptions(settings, subagentChatProvider);
  if (options.length === 0) {
    return '';
  }

  const normalizedCurrent = currentModelId.trim();
  if (normalizedCurrent && options.some((option) => option.value === normalizedCurrent)) {
    return normalizedCurrent;
  }

  return options[0]?.value ?? '';
};
